import { useEffect } from "react";
import Lenis from "lenis";

export default function ScrollEngine() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, smoothWheel: true, lerp: 0.08 });
    return () => lenis.destroy();
  }, []);
  return null;
}
